module.exports = __webpack_public_path__ + "img/avatar.864a2dfb.svg";